<template>
  <layout-default>
    <span slot="title">Rooms</span>
    <div class="flex flex-wrap content-center">
      <room-item v-for="room in rooms" :key="room.id" :room="room"></room-item>
    </div>
    <div class="bg-red-600 bg-purple-600 bg-blue-600 bg-green-600 bg-indigo-600"></div>
  </layout-default>
</template>
<script>
// @ is an alias to /src
import RoomItem from "@/components/RoomItem.vue";
import LayoutDefault from "@/components/layouts/LayoutDefault.vue";

export default {
  name: "Home",
  components: {
    LayoutDefault,
    RoomItem
  },
  computed: {
    rooms() {
      return this.$store.state.rooms;
    }
  },
  created() {
    this.$store.dispatch("getRooms");
    this.$store.dispatch("getMixerChannels");
  }
};
</script>
